var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tk-hotel-filter',_vm._g({attrs:{"selected-filter-options":_vm.filters,"filter-list":_vm.filterList,"key-word":_vm.keyWord}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }